/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

const useIntersectionObserver = (
  domElement: HTMLElement | null,
  useOnce?: boolean
) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!domElement) {
      return;
    }

    // Just set `isIntersecting` true if browser doesn't implement IntersectionObserver.
    if (
      !('IntersectionObserver' in window) ||
      !('IntersectionObserverEntry' in window) ||
      !('intersectionRatio' in window.IntersectionObserverEntry.prototype)
    ) {
      if (!isIntersecting) {
        setIntersecting(true);
      }

      // We want to return early, but `useEffect` expects a function as the return value,
      // so we just return a noop function.
      return () => null;
    }

    const observer = new IntersectionObserver(([entry]) => {
      const onScreen = entry.isIntersecting;
      setIntersecting(onScreen);
      if (useOnce && onScreen) {
        observer.disconnect();
      }
    });

    observer.observe(domElement);

    // Remove the observer as soon as the component is unmounted
    return () => {
      observer.disconnect();
    };
  }, [domElement]);

  return isIntersecting;
};

export default useIntersectionObserver;
